import React from "react";
import { useFleet } from "../providers/FleetProvider";

/**
 * A page heading that carries the group scope with it: "Devices (North Crew ✕)".
 *
 * The group picker lives in the topbar, a long way from the table once the reader has scrolled —
 * and on a narrow window it isn't on screen at all. A short list with no visible reason is the
 * failure this prevents: the scope is named where the count is read, and the ✕ clears back to all
 * groups from right there.
 *
 * Sized in em so it stays proportional whether it sits in a TableBar or an h1.
 */
export const PageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { group, setGroupId } = useFleet();

    return (
        <span className="inline-flex flex-wrap items-baseline gap-2">
            {children}
            {/* print:hidden — a filter chip with a dismiss button is screen furniture, and this
                heading sits above the cab card someone is printing. */}
            {group && (
                <span className="whitespace-nowrap text-[0.7em] font-semibold text-[var(--muted)] print:hidden">
                    ({group.name}{" "}
                    {/* Crit red, not the muted grey the rest of the chip uses: this is the one
                        part of the heading you can press, and it removes something. */}
                    <button
                        type="button"
                        onClick={() => setGroupId(undefined)}
                        aria-label={`Clear the ${group.name} filter and show all groups`}
                        title="Show all groups"
                        className="rounded px-1 font-bold text-[var(--crit)] hover:bg-[var(--crit)] hover:text-white"
                    >
                        ✕
                    </button>
                    )
                </span>
            )}
        </span>
    );
};
